import { c as _c } from "react/compiler-runtime";
import type { Call } from "@signalwire/js";
import { useCallback, useState } from "react";
interface UseCallMuteOptions {
  call: Call | null;
}
interface UseCallMuteReturn {
  isMuted: boolean;
  toggleMute: () => void;
  resetMute: () => void;
}
export function useCallMute(t0) {
  const $ = _c(7);
  const {
    call
  } = t0;
  const [isMuted, setIsMuted] = useState(false);
  let t1;
  if ($[0] !== call?.self || $[1] !== isMuted) {
    t1 = async () => {
      const self = call?.self;
      if (!self) {
        return;
      }
      ;
      try {
        if (isMuted) {
          await self.unmute();
        } else {
          await self.mute();
        }
        setIsMuted(!isMuted);
      } catch (t2) {
        const error = t2;
        console.error("[CallMute] Error toggling mute:", error);
      }
    };
    $[0] = call?.self;
    $[1] = isMuted;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const toggleMute = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsMuted(false);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const resetMute = t2;
  let t3;
  if ($[4] !== isMuted || $[5] !== toggleMute) {
    t3 = {
      isMuted,
      toggleMute,
      resetMute
    };
    $[4] = isMuted;
    $[5] = toggleMute;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}